import React, { useState } from "react";
import TableLoader from "../../../common/tableLoader";
import SectionRecordsFilter from "../../public-user/sections/common/section-records-filter";
import SectionPagination from "../../public-user/sections/common/section-pagination";
import { NavLink } from "react-router-dom";
import { loadScript } from "../../../../globals/constants";
import { useEffect } from "react";
import GetProfileImage from "../../../common/getProfileImage";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {doc,getDoc, updateDoc, setDoc, onSnapshot  } from 'firebase/firestore';
import { db } from "../../../common/firebase/firebase";
import { jobDetailsData } from "../../../../store/reducers/menu";

const CanJobList = ({
  jobLists,
  isLoading,
  getAllChats,
  setIsJobList,
  isJobList,
  setJobId,
  setJobIdAndGroupStatus,
  setIsGroupChat,
  setIsStartChat
}) => {
  const {isLoggedIn, role_type, userInfo } = useSelector((state) => state.menu);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _filterConfig = {
    prefix: "Showing",
    type: "results",
    isSorting: false,
    // total: paginationLocationData?.totalElements,
    total: 0,
    showRange: false,
    showingUpto: "",
  };
// const role_type=userInfo?.roleEntities[0]?.roleType
  useEffect(() => {
    loadScript("js/custom.js");
  });
  const getJobValue = (status, item) => {
    // console.log("statusssss", status, role_type);
    if (status === "eApplied" && role_type.includes("ROLE_USER")) {
      return <h4 style={{ color: "orange" }}>PENDING</h4>; // Return an empty string or handle it as needed
    } else if (status === "eAccepted" && role_type.includes("ROLE_USER")) {
      return <h4 style={{ color: "green" }}>HIRED</h4>;
    }else if (status === "eInprogress" && role_type.includes("ROLE_USER")) {
        return <h4 style={{ color: "green" }}>HIRED</h4>;
      } else if (
      ((status === "eCancelled" || status === "eInProgress") &&
        role_type.includes("ROLE_USER")) ||
      (status === "eInProgress" && role_type.includes("ROLE_INSTITUTION_ADMIN"))
    ) {
      return (
        <h4
          style={{
            color:
              item?.clockInStatus == "TIME PASSED"
                ? "black"
                : item?.clockInStatus === "Upcoming"
                ? "orange"
                : item?.clockInStatus === "Clocked Out"
                ? "red"
                : item?.clockInStatus === "Clocked In"
                ? "green"
                : "black",
          }}
        >
          {item?.clockInStatus?.toUpperCase()}
        </h4>
      );
    } else {
      return <h4>{status.startsWith("e") ? status.substring(1) : status}</h4>;
    }
  };
  const navigateToJobDetails = (item) => {
    // dispatch(jobDetailsData(item))
    navigate(`/job-detail/${item.id}`, { state: item });
  };
  const handleStartChat=async(jobItem, job_id, isGroupChat)=>{
        try {
          // const jobId=jobItem?.id
            const jobId = job_id;
            const currentDateInSeconds = Math.floor(new Date().getTime() / 1000);
            let chatCollection = isGroupChat ? "groupChats" : "chats";
            const docRef = doc(db, chatCollection, jobId);
            const docSnap = await getDoc(docRef);
            console.log("docRef.exists()", docSnap.exists())
            if(docSnap.exists()){
              setIsStartChat(true);
            }else{
              const userDetails = {
              id : userInfo?.id,
              email: userInfo?.email,
              firstName: userInfo?.firstName,
              lastName: userInfo?.lastName,
              roleType: userInfo?.roleEntities[0]?.roleType
              }
            
              let chatObj={}

               if(isGroupChat){
              const receiverDetails = {
                id :  role_type?.includes('ROLE_USER') ? jobItem?.userId || jobItem?.id : jobItem?.applicantUserId ? jobItem?.applicantUserId : jobItem?.hiredApplicants[0]?.applicantUserId,
                email:  role_type?.includes('ROLE_USER') ? jobItem?.email : jobItem?.applicantEmail ? jobItem?.applicantEmail : jobItem?.hiredApplicants[0]?.applicantEmail,
                firstName:  role_type?.includes('ROLE_USER') ? jobItem?.firstName : jobItem?.applicantFirstName ? jobItem?.applicantFirstName : jobItem?.hiredApplicants[0]?.applicantFirstName,
                lastName:  role_type?.includes('ROLE_USER') ? jobItem?.lastName : jobItem?.applicantLastName ? jobItem?.applicantLastName : jobItem?.hiredApplicants[0]?.applicantLastName,
                roleType:  role_type?.includes('ROLE_USER') ? "ROLE_INSTITUTION_ADMIN" : 'ROLE_USER'
              }

             const members = [userDetails, receiverDetails];

              chatObj = {
                groupId: jobId || "unknown",
                groupName: jobItem?.jobTitle,
                members: members,
                createdBy: userInfo?.id,
                createdOn: new Date(),
              };

              if(userInfo?.roleEntities[0]?.roleType != "ROLE_USER"){
                chatObj.receiverFirstName = role_type?.includes('ROLE_USER') ? jobItem?.firstName : jobItem?.applicantFirstName ? jobItem?.applicantFirstName : jobItem?.hiredApplicants[0]?.applicantFirstName;
                chatObj.receiverLastName = role_type?.includes('ROLE_USER') ? jobItem?.lastName :  jobItem?.applicantLastName ? jobItem?.applicantLastName : jobItem?.hiredApplicants[0]?.applicantLastName;
              }
            }else{
              if(userInfo?.roleEntities[0]?.roleType=="ROLE_USER"){
                chatObj={
                receiverId: jobItem?.userId|| 'unknown', // Replace with actual receiver ID
                receiverEmail: jobItem?.email|| 'unknown', // Replace with actual receiver email
                receiverFirstName: jobItem?.firstName|| 'unknown', // Replace with actual receiver first name
                receiverLastName: jobItem?.lastName|| 'unknown', 
                }
              }
                else if(userInfo?.roleEntities[0]?.roleType=="ROLE_INSTITUTION_ADMIN"){
                chatObj={ 
                receiverId: jobItem?.applicantUserId ? jobItem?.applicantUserId : jobItem?.hiredApplicants[0]?.applicantUserId || 'unknown', // Replace with actual receiver ID
                receiverEmail: jobItem?.applicantEmail ? jobItem?.applicantEmail : jobItem?.hiredApplicants[0]?.applicantEmail|| 'unknown', // Replace with actual receiver email
                receiverFirstName: jobItem?.applicantFirstName ? jobItem?.applicantFirstName : jobItem?.hiredApplicants[0]?.applicantFirstName || 'unknown', // Replace with actual receiver first name
                receiverLastName: jobItem?.applicantLastName ? jobItem?.applicantLastName : jobItem?.hiredApplicants[0]?.applicantLastName || 'unknown', 
                    }
                
              }
            }

            console.log("chatobject=====", chatObj)
              await setDoc(docRef, {
                message: [],
                jobId: jobId|| 'unknown',
                jobTitle: jobItem?.jobTitle|| 'unknown', // Replace with actual job title from props or state
                senderId: userInfo?.id|| 'unknown',
                senderEmail: userInfo?.email|| 'unknown',
                senderFirstname: userInfo?.firstName|| 'unknown',
                senderLastname: userInfo?.lastName|| 'unknown',
                startedOn:new Date(),
                _id: userInfo?.id+currentDateInSeconds,
                modifiedOn:new Date(),
                ...chatObj
              });
              getAllChats()
            }
            
        } catch (error) {
        }
  }

  const handleStartChatClick = (item, val) => {
    let job_id = item?.id;
    if (role_type?.includes("ROLE_USER")) {
      job_id = job_id + userInfo?.id;
    } else if (role_type?.includes("ROLE_INSTITUTION_ADMIN")) {
      if (val) {
        job_id = job_id + val?.applicantUserId;
      } else if (item?.hiredApplicants?.length > 0) {
        job_id = job_id + item?.hiredApplicants[0]?.applicantUserId;
      }
    }
    setIsJobList(!isJobList);
    navigate(`/chats/${job_id}`);
    setIsGroupChat(true);
    if (role_type?.includes("ROLE_USER")) {
      handleStartChat(item, job_id, true);
    } else if (role_type?.includes("ROLE_INSTITUTION_ADMIN")) {
      if(val){
      handleStartChat({...item, ...val}, job_id, true);
      }else{
      handleStartChat(item, job_id, true);
      }
    }
    setJobId(job_id);
    setJobIdAndGroupStatus({
      jobid: job_id,
      isGroupChat: true,
    });
  };

  return (
    <>
      {/* <SectionRecordsFilter
        _config={_filterConfig}
        // rowPerPage={rowLocationPerPage}
        // handleRecordsPerPageChange={handleRecordsLocationPerPageChange}
        // setTableFilter={setTableFilter}
        // tableFilter={tableFilter}
      /> */}
      <div className="twm-candidates-list-wrap">
        <ul style={{ height: "700px", overflow: "auto" }}>
          {!isLoading ? (
            jobLists?.length > 0 ? (
              jobLists?.map((item) => (
                <li>
                  <div className="twm-candidates-list-style1 mb-5">
                    <div className="twm-mid-content">
                      <div style={{ width: "100%", display: "inline-block" }}>
                        {/* <NavLink to="" className="twm-job-title"> */}
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <div className="d-flex align-items-center mb-3">
                            <div style={{ height: "50px", width: "70px" }}>
                              {item?.institutionEntityId && (
                                <GetProfileImage
                                  id={item?.institutionEntityId}
                                  type={"jobList"}
                                />
                              )}
                            </div>
                            <div className="ms-3">
                              <h4
                                className="mb-0"
                                style={{ cursor: "pointer" }}
                                onClick={() => navigateToJobDetails(item)}
                              >
                                {item?.jobTitle}
                              </h4>
                              {getJobValue(item?.jobStatus, item, role_type)}
                              {item?.hiredApplicants?.length > 0 &&
                                item?.hiredApplicants?.map((val) => (
                                  <div class="d-flex justify-content-between align-items-center mb-2">
                                    <p className="twm-candidate-address">
                                      {val?.applicantFirstName +
                                        " " +
                                        val?.applicantLastName}
                                    </p>
                                    <button
                                      className="site-button button-sm ms-5 float-right"
                                      onClick={() => {
                                        handleStartChatClick(item, val);
                                      }}
                                    >
                                      <i className="fas fa-comments ms-3"></i>{" "}
                                      Start Chat
                                    </button>
                                  </div>
                                ))}
                            </div>
                          </div>
                          {role_type?.includes("ROLE_USER") && (
                            <div className="d-flex align-items-center">
                              <button
                                className="site-button button-sm my-3 float-right"
                                onClick={() => {
                                  handleStartChatClick(item);
                                }}
                              >
                                <i className="fas fa-comments ms-3"></i> Start
                                Chat
                              </button>
                            </div>
                          )}
                        </div>
                        {/* </NavLink> */}
                        <div>
                          {item?.jobPosition && (
                            <p className="twm-candidate-address">
                              {" "}
                              Position : {item?.jobPosition}
                            </p>
                          )}
                          {!role_type.includes("ROLE_INSTITUTION_ADMIN") && (
                            <p className="twm-candidate-address">
                              {" "}
                              Poster : {item?.firstName + " " + item?.lastName}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))
            ) : (
              "No results found."
            )
          ) : (
            <TableLoader />
          )}
        </ul>
        {/* <SectionPagination
          currentPage={locationCurrentPage}
          setCurrentPage={setLocationCurrentPage}
          totalPages={paginationLocationData?.totalPages}
        /> */}
        {/* <PostJobPopup
          selectedItemId={selectedItemId}
          empDetailId={empDetailId}
          modalShow={modalShow}
        /> */}
      </div>
    </>
  );
};

export default CanJobList;
